<template>
  <div
    v-if="usageStats && usageStats[column] != null"
    class="p-l-10 live-counter-cell d-flex flex-row"
  >
    <LiveCounter flickerClass="flicker-table-data">
      <CappedValueDisplay
        :value="usageStats[column]"
        :cap="capSetting"
        :isAmountType="isAmountType"
        :column="column"
      ></CappedValueDisplay>
    </LiveCounter>
  </div>
</template>

<script>
import LiveCounter from '@/core/components/LiveCounter/LiveCounter.vue';
import CappedValueDisplay from '@/core/components/CappedValueDisplay/CappedValueDisplay';

export default {
  name: 'LiveCounterCell',
  components: {
    LiveCounter,
    CappedValueDisplay,
  },
  props: {
    usageStats: {
      type: Object | undefined,
    },
    caps: {
      type: Object | undefined,
    },
    isAmountType: {
      type: Boolean,
      required: true,
    },
    column: {
      type: String,
      required: true,
    },
  },
  computed: {
    capSetting() {
      const capMap = {
        currentLive: this.caps?.live,
        currentLiveSum: this.caps?.live,
        currentHour: this.caps?.hour,
        currentHourSum: this.caps?.hourSum,
        currentDay: this.caps?.day,
        currentDaySum: this.caps?.daySum,
        currentMonth: this.caps?.month,
        currentMonthSum: this.caps?.monthSum,
        total: this.caps?.total,
        totalSum: this.caps?.totalSum,
      };
      return capMap[this.column] ?? 0;
    },
  },
};
</script>
